<div #container [attr.id]="id" [ngClass]="containerClass" [ngStyle]="style" [class]="styleClass" (click)="onContainerClick($event)">
    <div class="p-hidden-accessible" [attr.data-p-hidden-accessible]="true">
        <input
            #focusInput
            [pTooltip]="tooltip"
            [tooltipPosition]="tooltipPosition"
            [positionStyle]="tooltipPositionStyle"
            [tooltipStyleClass]="tooltipStyleClass"
            [attr.aria-disabled]="disabled"
            [attr.id]="inputId"
            role="combobox"
            [attr.aria-label]="ariaLabel"
            [attr.aria-labelledby]="ariaLabelledBy"
            [attr.aria-haspopup]="'listbox'"
            [attr.aria-expanded]="overlayVisible ?? false"
            [attr.aria-controls]="overlayVisible ? id + '_list' : null"
            [attr.tabindex]="!disabled ? tabindex : -1"
            [attr.aria-activedescendant]="focused ? focusedOptionId : undefined"
            (focus)="onInputFocus($event)"
            (blur)="onInputBlur($event)"
            (keydown)="onKeyDown($event)"
            pAutoFocus
            [autofocus]="autofocus"
        />
    </div>
    <div
        class="p-multiselect-label-container"
        [pTooltip]="tooltip"
        (mouseleave)="labelContainerMouseLeave()"
        [tooltipDisabled]="_disableTooltip"
        [tooltipPosition]="tooltipPosition"
        [positionStyle]="tooltipPositionStyle"
        [tooltipStyleClass]="tooltipStyleClass"
    >
        <div [ngClass]="labelClass">
            <ng-container *ngIf="!selectedItemsTemplate">
                <ng-container *ngIf="display === 'comma'">{{ label() || 'empty' }}</ng-container>
                <ng-container *ngIf="display === 'chip'">
                    <div #token *ngFor="let item of chipSelectedItems(); let i = index" class="p-multiselect-token">
                        <span class="p-multiselect-token-label">{{ getLabelByValue(item) }}</span>
                        <ng-container *ngIf="!disabled">
                            <TimesCircleIcon *ngIf="!removeTokenIconTemplate" [styleClass]="'p-multiselect-token-icon'" (click)="removeOption(item, $event)" [attr.data-pc-section]="'clearicon'" [attr.aria-hidden]="true" />
                            <span *ngIf="removeTokenIconTemplate" class="p-multiselect-token-icon" (click)="removeOption(item, $event)" [attr.data-pc-section]="'clearicon'" [attr.aria-hidden]="true">
                                <ng-container *ngTemplateOutlet="removeTokenIconTemplate"></ng-container>
                            </span>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="!modelValue() || modelValue().length === 0">{{ placeholder() || defaultLabel || 'empty' }}</ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngTemplateOutlet="selectedItemsTemplate!; context: { $implicit: selectedOptions, removeChip: removeOption.bind(this) }"></ng-container>
        </div>
        <ng-container *ngIf="isVisibleClearIcon">
            <TimesIcon *ngIf="!clearIconTemplate" [styleClass]="'p-multiselect-clear-icon'" (click)="clear($event)" [attr.data-pc-section]="'clearicon'" [attr.aria-hidden]="true" />
            <span *ngIf="clearIconTemplate" class="p-multiselect-clear-icon" (click)="clear($event)" [attr.data-pc-section]="'clearicon'" [attr.aria-hidden]="true">
                <ng-template *ngTemplateOutlet="clearIconTemplate"></ng-template>
            </span>
        </ng-container>
    </div>
    <div class="p-multiselect-trigger">
        <ng-container *ngIf="!dropdownIconTemplate">
            <span *ngIf="dropdownIcon" class="p-multiselect-trigger-icon" [ngClass]="dropdownIcon" [attr.data-pc-section]="'triggericon'" [attr.aria-hidden]="true"></span>
            <ChevronDownIcon *ngIf="!dropdownIcon" [styleClass]="'p-multiselect-trigger-icon'" [attr.data-pc-section]="'triggericon'" [attr.aria-hidden]="true" />
        </ng-container>
        <span *ngIf="dropdownIconTemplate" class="p-multiselect-trigger-icon" [attr.data-pc-section]="'triggericon'" [attr.aria-hidden]="true">
            <ng-template *ngTemplateOutlet="dropdownIconTemplate"></ng-template>
        </span>
    </div>
    <p-overlay
        #overlay
        [(visible)]="overlayVisible!"
        [options]="overlayOptions"
        [target]="'@parent'"
        [appendTo]="appendTo"
        [autoZIndex]="autoZIndex!"
        [baseZIndex]="baseZIndex!"
        [showTransitionOptions]="showTransitionOptions!"
        [hideTransitionOptions]="hideTransitionOptions!"
        (onAnimationStart)="onOverlayAnimationStart($event)"
        (onHide)="hide()"
    >
        <ng-template pTemplate="content">
            <div [attr.id]="id + '_list'" [ngClass]="'p-multiselect-panel p-component'" [ngStyle]="panelStyle" [class]="panelStyleClass!">
                <span
                    #firstHiddenFocusableEl
                    role="presentation"
                    class="p-hidden-accessible p-hidden-focusable"
                    [attr.tabindex]="0"
                    (focus)="onFirstHiddenFocus($event)"
                    [attr.data-p-hidden-accessible]="true"
                    [attr.data-p-hidden-focusable]="true"
                >
                </span>
                <div class="p-multiselect-header" *ngIf="showHeader">
                    <ng-content select="p-header"></ng-content>
                    <ng-container *ngTemplateOutlet="headerTemplate!"></ng-container>
                    <ng-container *ngIf="filterTemplate; else builtInFilterElement">
                        <ng-container *ngTemplateOutlet="filterTemplate; context: { options: filterOptions }"></ng-container>
                    </ng-container>
                    <ng-template #builtInFilterElement>
                        <div
                            class="p-checkbox p-component"
                            *ngIf="showToggleAll && !selectionLimit"
                            [ngClass]="{ 'p-checkbox-disabled': disabled || toggleAllDisabled }"
                            (click)="onToggleAll($event)"
                            (keydown)="onHeaderCheckboxKeyDown($event)"
                        >
                            <div class="p-hidden-accessible" [attr.data-p-hidden-accessible]="true">
                                <input
                                    #headerCheckbox
                                    type="checkbox"
                                    [readonly]="readonly"
                                    [attr.checked]="allSelected()"
                                    (focus)="onHeaderCheckboxFocus()"
                                    (blur)="onHeaderCheckboxBlur()"
                                    [disabled]="disabled || toggleAllDisabled"
                                    [attr.aria-label]="toggleAllAriaLabel"
                                />
                            </div>
                            <div
                                class="p-checkbox-box"
                                role="checkbox"
                                [attr.aria-label]="toggleAllAriaLabel"
                                [attr.aria-checked]="allSelected()"
                                [ngClass]="{ 'p-highlight': allSelected(), 'p-focus': headerCheckboxFocus, 'p-disabled': disabled || toggleAllDisabled }"
                            >
                                <ng-container *ngIf="allSelected() || partialSelected()">
                                    <ng-container *ngIf="!checkIconTemplate && !headerCheckboxIconTemplate">
                                        <CheckIcon [styleClass]="'p-checkbox-icon'" *ngIf="allSelected()" [attr.aria-hidden]="true" />
                                    </ng-container>

                                    <span *ngIf="checkIconTemplate" class="p-checkbox-icon" [attr.aria-hidden]="true">
                                        <ng-template *ngTemplateOutlet="checkIconTemplate; context: { $implicit: allSelected() }"></ng-template>
                                    </span>
                                    <span *ngIf="headerCheckboxIconTemplate" class="p-checkbox-icon" [attr.aria-hidden]="true">
                                        <ng-template *ngTemplateOutlet="headerCheckboxIconTemplate; context: { $implicit: allSelected(), partialSelected: partialSelected() }"></ng-template>
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="p-multiselect-filter-container" *ngIf="filter">
                            <input
                                #filterInput
                                type="text"
                                role="searchbox"
                                [attr.autocomplete]="autocomplete"
                                [attr.placeholder]="filterPlaceHolder"
                                role="searchbox"
                                [attr.aria-owns]="id + '_list'"
                                [attr.aria-activedescendant]="focusedOptionId"
                                [value]="_filterValue() || ''"
                                (input)="onFilterInputChange($event)"
                                (keydown)="onFilterKeyDown($event)"
                                (click)="onInputClick($event)"
                                (blur)="onFilterBlur($event)"
                                class="p-multiselect-filter p-inputtext p-component"
                                [disabled]="disabled"
                                [attr.placeholder]="filterPlaceHolder"
                                [attr.aria-label]="ariaFilterLabel"
                            />
                            <SearchIcon [styleClass]="'p-multiselect-filter-icon'" *ngIf="!filterIconTemplate" />
                            <span *ngIf="filterIconTemplate" class="p-multiselect-filter-icon">
                                <ng-template *ngTemplateOutlet="filterIconTemplate"></ng-template>
                            </span>
                        </div>

                        <button class="p-multiselect-close p-link p-button-icon-only" type="button" (click)="close($event)" pRipple [attr.aria-label]="closeAriaLabel">
                            <TimesIcon [styleClass]="'p-multiselect-close-icon'" *ngIf="!closeIconTemplate" />
                            <span *ngIf="closeIconTemplate" class="p-multiselect-close-icon">
                                <ng-template *ngTemplateOutlet="closeIconTemplate"></ng-template>
                            </span>
                        </button>
                    </ng-template>
                </div>
                <div class="p-multiselect-items-wrapper" [style.max-height]="virtualScroll ? 'auto' : scrollHeight || 'auto'">
                    <p-scroller
                        *ngIf="virtualScroll"
                        #scroller
                        [items]="visibleOptions()"
                        [style]="{ height: scrollHeight }"
                        [itemSize]="virtualScrollItemSize! || _itemSize!"
                        [autoSize]="true"
                        [tabindex]="-1"
                        [lazy]="lazy"
                        (onLazyLoad)="onLazyLoad.emit($event)"
                        [options]="virtualScrollOptions"
                    >
                        <ng-template pTemplate="content" let-items let-scrollerOptions="options">
                            <ng-container *ngTemplateOutlet="buildInItems; context: { $implicit: items, options: scrollerOptions }"></ng-container>
                        </ng-template>
                        <ng-container *ngIf="loaderTemplate">
                            <ng-template pTemplate="loader" let-scrollerOptions="options">
                                <ng-container *ngTemplateOutlet="loaderTemplate; context: { options: scrollerOptions }"></ng-container>
                            </ng-template>
                        </ng-container>
                    </p-scroller>
                    <ng-container *ngIf="!virtualScroll">
                        <ng-container *ngTemplateOutlet="buildInItems; context: { $implicit: visibleOptions(), options: {} }"></ng-container>
                    </ng-container>

                    <ng-template #buildInItems let-items let-scrollerOptions="options">
                        <ul #items class="p-multiselect-items p-component" [ngClass]="scrollerOptions.contentStyleClass" [style]="scrollerOptions.contentStyle" role="listbox" aria-multiselectable="true" [attr.aria-label]="listLabel">
                            <ng-template ngFor let-option [ngForOf]="items" [ngForTrackBy]="trackByFn" let-i="index">
                                <ng-container *ngIf="isOptionGroup(option)">
                                    <li [attr.id]="id + '_' + getOptionIndex(i, scrollerOptions)" class="p-multiselect-item-group" [ngStyle]="{ height: scrollerOptions.itemSize + 'px' }" role="option">
                                        <span *ngIf="!groupTemplate">{{ getOptionGroupLabel(option.optionGroup) }}</span>
                                        <ng-container *ngTemplateOutlet="groupTemplate!; context: { $implicit: option.optionGroup }"></ng-container>
                                    </li>
                                </ng-container>
                                <ng-container *ngIf="!isOptionGroup(option)">
                                    <p-multiSelectItem
                                        [id]="id + '_' + getOptionIndex(i, scrollerOptions)"
                                        [option]="option"
                                        [selected]="isSelected(option)"
                                        [label]="getOptionLabel(option)"
                                        [disabled]="isOptionDisabled(option)"
                                        [template]="itemTemplate"
                                        [checkIconTemplate]="checkIconTemplate"
                                        [itemCheckboxIconTemplate]="itemCheckboxIconTemplate"
                                        [itemSize]="scrollerOptions.itemSize"
                                        [focused]="focusedOptionIndex() === getOptionIndex(i, scrollerOptions)"
                                        [ariaPosInset]="getAriaPosInset(getOptionIndex(i, scrollerOptions))"
                                        [ariaSetSize]="ariaSetSize"
                                        (onClick)="onOptionSelect($event, false, getOptionIndex(i, scrollerOptions))"
                                        (onMouseEnter)="onOptionMouseEnter($event, getOptionIndex(i, scrollerOptions))"
                                    ></p-multiSelectItem>
                                </ng-container>
                            </ng-template>

                            <li *ngIf="hasFilter() && isEmpty()" class="p-multiselect-empty-message" [ngStyle]="{ height: scrollerOptions.itemSize + 'px' }" role="option">
                                <ng-container *ngIf="!emptyFilterTemplate && !emptyTemplate; else emptyFilter">
                                    {{ emptyFilterMessageLabel }}
                                </ng-container>
                                <ng-template #emptyFilter>
                                    <ng-container *ngTemplateOutlet="emptyFilterTemplate! || emptyTemplate"></ng-container>
                                </ng-template>
                                <!-- <ng-container #emptyFilter *ngTemplateOutlet="emptyFilterTemplate! || emptyTemplate"></ng-container> -->
                            </li>
                            <li *ngIf="!hasFilter() && isEmpty()" class="p-multiselect-empty-message" [ngStyle]="{ height: scrollerOptions.itemSize + 'px' }" role="option">
                                <ng-container *ngIf="!emptyTemplate; else empty">
                                    {{ emptyMessageLabel }}
                                </ng-container>
                                <ng-template #empty>
                                    <ng-container *ngTemplateOutlet="emptyTemplate!"></ng-container>
                                </ng-template>
                                <!-- <ng-container #empty *ngTemplateOutlet="emptyTemplate!"></ng-container> -->
                            </li>
                        </ul>
                    </ng-template>
                </div>
                <div class="p-multiselect-footer" *ngIf="footerFacet || footerTemplate">
                    <ng-content select="p-footer"></ng-content>
                    <ng-container *ngTemplateOutlet="footerTemplate!"></ng-container>
                </div>

                <span
                    #lastHiddenFocusableEl
                    role="presentation"
                    class="p-hidden-accessible p-hidden-focusable"
                    [attr.tabindex]="0"
                    (focus)="onLastHiddenFocus($event)"
                    [attr.data-p-hidden-accessible]="true"
                    [attr.data-p-hidden-focusable]="true"
                ></span>
            </div>
        </ng-template>
    </p-overlay>
</div>